/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Complete_Setup_HeadingInputs */

const en_plan_complete_setup_heading = /** @type {(inputs: Plan_Complete_Setup_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Subscription Setup Now`)
};

const es_plan_complete_setup_heading = /** @type {(inputs: Plan_Complete_Setup_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa la configuración de tu suscripción ahora`)
};

/**
* | output |
* | --- |
* | "Complete Subscription Setup Now" |
*
* @param {Plan_Complete_Setup_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_complete_setup_heading = /** @type {((inputs?: Plan_Complete_Setup_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Complete_Setup_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_complete_setup_heading(inputs)
	return en_plan_complete_setup_heading(inputs)
});